import React from 'react';

export function MailCampaignsTableToolbar() {
  return <></>;
}
